import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { CommandService, injectService } from '@patsnap/tahiti-core';
import { removeHistoryQueries } from '@telecom/shared/utils/html';

const PAYMENT_SUCCESS_STATE = 'success';
const AUTHORIZATION_STORAGE_KEY = 'patsnap-authorizations';
const PAYMENT_SUCCESS_RELOAD_DELAY = 3000;

export function usePaymentSuccessCallback(options: {
    commandService?: Pick<CommandService, 'executeCommand'>;
    removeQueries?: (queryKeys: string[]) => void;
    storage?: Pick<Storage, 'removeItem'>;
    reload?: () => void;
    setReloadTimeout?: (handler: () => void, timeout: number) => unknown;
} = {}) {
    const route = useRoute();
    const handled = ref(false);
    const commandService = options.commandService ?? injectService<CommandService>(CommandService);
    const removeQueries = options.removeQueries ?? removeHistoryQueries;
    const storage = options.storage ?? localStorage;
    const reload = options.reload ?? window.location.reload.bind(window.location);
    const setReloadTimeout = options.setReloadTimeout ?? window.setTimeout.bind(window);

    return watch(
        () => route.query.payment_state,
        (paymentState) => {
            if (handled.value || paymentState !== PAYMENT_SUCCESS_STATE) {
                return;
            }

            handled.value = true;
            void commandService.executeCommand('plg:open-payment-success-dialog');
            removeQueries(['payment_state']);
            storage.removeItem(AUTHORIZATION_STORAGE_KEY);
            setReloadTimeout(() => {
                reload();
            }, PAYMENT_SUCCESS_RELOAD_DELAY);
        },
        {
            immediate: true,
        },
    );
}
